import { Question } from '../../question.class';
import { WeeklyTableHandler } from './weekly-table-handler';
import { getPropertyDescriptor } from '../../../../functions';

declare module '../../question.class' {
  interface Question {
    weeklyTable: WeeklyTableHandler;
  }
}

const type = 'weekly-table';

let QuestionValue = getPropertyDescriptor(Question.prototype, 'value');
Object.defineProperty(Question.prototype, 'value', {
  get: function(): boolean {
    if (this.type === type) {
      return {
        weeklyTable: this.get(['weeklyTable']),
        ...QuestionValue.get.apply(this)
      };
    } else {
      return QuestionValue.get.apply(this);
    }
  }
});
let QuestionInit = Question.prototype.init;
Question.prototype.init = function(...args) {
  if (args[0] === type) {
    this.weeklyTable = new WeeklyTableHandler(this);
    if (!this.weeklyTable.value) {
      // if table not set, set the default value
      const now = Date.now();
      (<WeeklyTableHandler>this.weeklyTable).resetColumns([
        new Date(now),
        new Date(now + 6 * 24 * 60 * 60 * 1000)
      ]);
      (<WeeklyTableHandler>this.weeklyTable).resetRows(4);
    }
    QuestionInit.apply(this, args);
  } else {
    QuestionInit.apply(this, args);
  }
};
let QuestionOnComposeInit = Question.prototype.onComposeInit;
Question.prototype.onComposeInit = function(...args) {
  if (args[0] === type) {
    //no sub question, no options allowed.
    (<Question>this).deleteOptions(undefined);
    (<Question>this).getDecendantQuestions().forEach(q => q.survey.deleteQuestions({ id: q.id }));
    (<Question>this).set('canHaveQuotaOptions', true);

    this.weeklyTable = new WeeklyTableHandler(this);
    const now = Date.now();
    (<WeeklyTableHandler>this.weeklyTable).resetColumns([
      new Date(now),
      new Date(now + 6 * 24 * 60 * 60 * 1000)
    ]);
    (<WeeklyTableHandler>this.weeklyTable).resetRows(4);
  } else {
    QuestionOnComposeInit.apply(this, args);
  }
};
let QuestionOnComposeDestroy = Question.prototype.onComposeDestroy;
Question.prototype.onComposeDestroy = function(...args) {
  if (args[0] === type) {
    delete (<Question>this).weeklyTable;
    QuestionOnComposeDestroy.apply(this, args);
  } else {
    QuestionOnComposeDestroy.apply(this, args);
  }
};

console.log("question type weekly-table is added");